import { AngkatanDocument } from '~/apollo/gql/graphql'
import type { Option } from '~/types/form'

export const useAngkatanOptions = () => {
  const { result, loading, load } = useLazyQuery(AngkatanDocument)

  const options: ComputedRef<Option<number>[]> = computed(() => {
    if (!result.value) return []

    return result.value.angkatan.map(angkatan => ({
      label: angkatan.name,
      value: angkatan.id
    }))
  })

  return { load, loading, options }
}
